export default "__VITE_ASSET__CAwWKB8h__"